const spacesRegExp = /\s/g;

const functionRegExp = /(Min|RoundUp|RoundDown|SubtractingDates)/g;

const mathSymbolsRegExp = /\(([^)]+)\)|[+/\-*^,]/g;
const divisionRegExp = /\(/g;

// function escapeRegExp(string) {
//   return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
// }

export class functionParserService {
  static isAllSquareBracketsClosed(str) {
    let stack = [];

    for (let i = 0; i < str.length; i++) {
      if (str[i] === "[") {
        stack.push("[");
      }
      if (str[i] === "]") {
        if (stack.length === 0 || stack.pop() !== "[") {
          return false;
        }
      }
    }
    if (stack.length === 0) {
      return true;
    }

    return false;
  }

  // static createFunctionValue(functionString, variablesForCondition) {
  //   if (!functionString) return;

  //   let currentExpressionString = functionString.replace(/\s+/g, "");

  //   const replacedValueObject = variablesForCondition.reduce((res, item) => {
  //     const currentReplaceString = item.label.replace(/\s+/g, "");
  //     const regex = new RegExp(escapeRegExp(currentReplaceString), "g");
  //     const matches = currentExpressionString.match(regex)?.length ?? 0;
  //     if (matches > 0) {
  //       res[currentReplaceString] = {
  //         matches,
  //         item
  //       };
  //     }
  //     return res;
  //   }, {});

  //   const arraySortedVariables = Object.entries(replacedValueObject)
  //     .sort(([, count1], [, count2]) => count2.matches - count1.matches || -1)
  //     .map(([_, { item }]) => item);

  //   arraySortedVariables.forEach(({ label, formulaKey }) => {
  //     const currentReplaceString = label.replace(/\s+/g, "");
  //     currentExpressionString = currentExpressionString.replaceAll(
  //       currentReplaceString,
  //       formulaKey
  //     );
  //   });

  //   currentExpressionString = currentExpressionString.replace(/\[[^\[\]]*\]/g, match => {
  //     if (match.includes('[') && match.includes(']')) return match;
  //     return match.slice(1, -1);
  //   });

  //   return currentExpressionString;
  // }

  static parseStringToSearchValue(string) {
    if (!string) {
      return null;
    }

    //replace for division
    string = string?.replace(divisionRegExp, "");
    //function parse regExp
    string = string?.replace(functionRegExp, "");

    const stack = [];

    const wordStack = [];

    let currentString = null;

    //find value after squad brackets "["
    for (let index = 0; index < string.length; index++) {
      const character = string[index];
      if (character !== "]" && index !== 0) {
        if (character === "[") {
          stack.push(character);
        }
        wordStack.push(character);
        currentString = wordStack.join("");
      } else if (character === "[") {
        stack.push(character);
      } else {
        if (stack.length === 1) {
          currentString = null;
        } else {
          stack.pop();
          wordStack.push(character);
        }
      }
    }

    return currentString;
  }

  static getUnclosedVariableValue(string, cursorPoint) {
    const currentString = string
      ?.slice(0, cursorPoint)
      .replace(spacesRegExp, "");

    const parts = currentString.split(mathSymbolsRegExp).filter((string) => {
      if (!string) {
        return false;
      }
      return string?.trim() !== "";
    });
    const currentValue = parts.at(-1)?.trim();
    const result = this.parseStringToSearchValue(currentValue);

    return result;
  }

  static insertString({
    insertString,
    initialString,
    cursorIndex,
    replaceString,
    characterEndedString,
  }) {
    let newValue = initialString;

    let functionIndex = replaceString ? cursorIndex - 1 : cursorIndex;

    let replaceStringArray = replaceString ? replaceString?.split("") : ["["];

    for (let index = replaceStringArray.length - 1; index >= 0; index--) {
      if (index === 0) {
        const startValue = newValue?.slice(0, functionIndex) ?? "";
        const endValue =
          newValue?.slice(cursorIndex, newValue.length).trim() ?? "";
        newValue = startValue + insertString + characterEndedString + endValue;
      } else {
        functionIndex = functionIndex - 1;
      }
    }
    return newValue;
  }
}
